import subscriptionReducer from "./subscriptionSlice";

export default subscriptionReducer;
